<template>
    <div>
      <head-top :navActive="navActive" v-on:navClick="navClickFun"></head-top>
      <!-- 内容 start -->
      <div class="description-first-bg"></div>
      <div class="description-first-main" v-html="innerHtml">

      </div>
      <!-- 内容 end -->
      <foot-bottom></foot-bottom>
    </div>
</template>

<script>
  import headTop from '../components/header/head-top'
  import footBottom from '../components/footer/foot-bottom'
  import tool from '../assets/js/tool.js'
    export default {
        name: "description-first",
        data () {
          return {
            navActive: 1,
            innerHtml: '',
          }
        },
        components: {
          headTop,
          footBottom,
        },
        methods: {
          navClickFun (id) {
            this.getInnerHtml(id);
          },
          getInnerHtml (id) {
            let data = {
              type: 1,
              category_id: id
            };
            tool.postData('get_system_list',data,(res) => {
              this.innerHtml = res.data.data.information_detail.content;
            });
          }
        },
        mounted () {
          let data = {
            type: 1,
            category_id: this.$route.query.id
          };
          tool.postData('get_system_list',data,(res) => {
            this.innerHtml = res.data.data.information_detail.content;
          });
        }
    }
</script>

<style scoped lang="scss">
  @import "../assets/style/common";
  .description-first-bg{
    width: 100%;
    height: 80px;
    background: url("../../static/img/nav.png");
  }
  .description-first-main{
    width: $box-width;
    margin: 0 auto;
    padding-top: 40px;
    box-sizing: border-box;
    padding-bottom: 120px;
    .colour-txt{
      @include font(16px,#ff0400);
      line-height: 30px;
      padding-bottom: 17px;
      box-sizing: border-box;
      border-bottom: 1px solid #e5e5e5;
    }
    .description-first-txt{
      @include font(16px,#3b3b3b);
      line-height: 30px;
      margin: 20px 0;
      span{
        color: #ff0400;
      }
    }
    .last-description-txt{
      padding: 20px 0;
      border-bottom: 1px solid #e5e5e5;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/description-first.vue